import _ from 'lodash';
import React, { Component } from 'react';
import {
  CardNumberElement,
  CardCVCElement,
  CardExpiryElement,
  PostalCodeElement,
} from 'react-stripe-elements';
import './style.css';

class PaymentForm extends Component {
  constructor() {
    super();

    this.state = {
      errors: {
        cardNumber: null,
        cvc: null,
        expiry: null,
        postal: null,
        customer: 'Invalid stripe customer',
      },
    };

    this.handleChangeFor.bind(this);
  }

  handleChangeFor = (changeObject, type) => {
    return ({ error }) => {
      this.props.onChange && this.props.onChange(changeObject);

      const { errors } = this.state;

      // if error exists update this field's error message
      if (error) {
        errors[type] = error.message;
      } else {
        errors[type] = null;
      }

      this.setState({ errors });
    };
  };

  styleElements = () => {
    // get an array of all 'div.form-group' elements in the form
    const formGroups = this.paymentMethodForm.getElementsByClassName(
      'form-group'
    );

    // set has-success/has-error based on the form-group
    // based on the class of the child span element
    // form-control-success and form-control-danger are inserted by
    // react-stripe-elements based on classOverrides
    _(formGroups).forEach((group) => {
      if (group.getElementsByClassName('form-control-success').length > 0) {
        group.classList.add('has-success');
        group.classList.remove('has-error'); // bootstrap-3 class
        group.classList.remove('has-danger'); // bootstrap-4 class
      } else if (
        group.getElementsByClassName('form-control-danger').length > 0
      ) {
        group.classList.remove('has-success');
        group.classList.add('has-error'); // bootstrap-3 class
        group.classList.add('has-danger'); // bootstrap-4 class
      } else {
        group.classList.remove('has-success');
        group.classList.remove('has-error'); // bootstrap-3 class
        group.classList.remove('has-danger'); // bootstrap-4 class
      }
    });
  };

  renderAlert(type) {
    // if errors contains the correct type, return a help-block
    // replace 'form-control-feedback' with 'help-block' for Bootstrap 3
    if (this.state.errors && this.state.errors[type]) {
      return (
        <span className="form-control-feedback">{this.state.errors[type]}</span>
      );
    }
    return null;
  }

  render() {
    const { hasCards, hidePostalCode, hideFieldName } = this.props;

    const classOverrides = {
      base: 'form-control',
      complete: 'form-control-success',
      empty: 'form-control-empty',
      invalid: 'form-control-danger invalid',
    };

    return (
      <div
        className="payment-form text-left"
        ref={(form) => {
          this.paymentMethodForm = form;
        }}
      >
        <div className="form-group mb-2">
          {!hideFieldName && (
            <small className="d-block text-muted mb-2">Card Number</small>
          )}
          <div className="payment-form__number">
            <CardNumberElement
              classes={classOverrides}
              style={{ base: { fontSize: '16px' } }}
              onChange={(changeObject) => this.handleChangeFor(changeObject, 'cardNumber')}
              onBlur={this.styleElements.bind(this)}
            />
            {hasCards && (
              <div className="payment-form__number-images">
                <img
                  style={{ width: 13, height: 17 }}
                  className="mr-1"
                  src="/assets/lock.png"
                  alt="lock"
                />
                <img
                  style={{ height: '100%' }}
                  src="/assets/credit-cards.png"
                  alt="cards"
                />
              </div>
            )}
          </div>
          {this.renderAlert('cardNumber')}
        </div>
        <div className="row">
          <div className="form-group col-6 mb-3">
            <CardExpiryElement
              classes={classOverrides}
              style={{ base: { fontSize: '16px' } }}
              onChange={this.handleChangeFor('expiry')}
              onBlur={this.styleElements.bind(this)}
            />
            {this.renderAlert('expiry')}
          </div>
          <div
            className="form-group col-6 mb-3"
            style={{ paddingLeft: '29px' }}
          >
            <CardCVCElement
              classes={classOverrides}
              style={{ base: { fontSize: '16px' } }}
              onChange={this.handleChangeFor('cvc')}
              onBlur={this.styleElements.bind(this)}
            />
            {this.renderAlert('cvc')}
          </div>
        </div>
        {!hidePostalCode && (
          <div className="form-group mb-3">
            {!hideFieldName && (
              <small className="d-block text-muted mb-2">
                Zip Code/Postal Code
              </small>
            )}
            <PostalCodeElement
              classes={classOverrides}
              style={{ base: { fontSize: '16px' } }}
              onChange={this.handleChangeFor('postal')}
              onBlur={this.styleElements.bind(this)}
            />
            {this.renderAlert('postal')}
          </div>
        )}
      </div>
    );
  }
}

export default PaymentForm;



// WEBPACK FOOTER //
// ./src/components/forms/PaymentForm/index.js